/* Pop Convert renders inside a shadow root. Keep its campaigns and dismissal
   handlers intact, and enhance only the existing six discount announcements. */
(() => {
  const script = document.currentScript;
  const stylesheet = script?.dataset.stylesheet;
  const logo = script?.dataset.logo;
  if (!stylesheet || !logo) return;

  const campaigns = new Map([
    ['114531', 'en'], ['114544', 'fr'],
    ['114562', 'en'], ['114548', 'en'],
    ['114541', 'fr'], ['114563', 'fr']
  ]);
  const copy = {
    en: { eyebrow: 'SAVINGS FOR YOUR PRACTICE', title: 'Stock up. Save more.', close: 'Close offer', continue: 'Continue shopping' },
    fr: { eyebrow: 'DES ÉCONOMIES POUR VOTRE CABINET', title: 'Faites le plein. Économisez.', close: 'Fermer l’offre', continue: 'Continuer mes achats' }
  };
  const node = (tag, className, text) => {
    const el = document.createElement(tag);
    el.className = className;
    if (text) el.textContent = text;
    return el;
  };

  function enhance(root) {
    for (const [id, language] of campaigns) {
      const content = root.querySelector(`.pc-campaign-${id}`);
      const card = content?.closest('.modal-card');
      if (!card || card.dataset.pfdPromo) continue;
      const original = content.querySelector('.text-block');
      const close = card.querySelector('#pc-main-close-button');
      if (!original || !close) continue;

      // Read the offer from the app, so its wording and discounts stay authoritative.
      const text = original.cloneNode(true);
      text.querySelectorAll('br').forEach(el => el.replaceWith('\n'));
      text.querySelectorAll('h1,h2,p').forEach(el => el.append('\n'));
      const lines = text.textContent.split('\n').map(line => line.trim()).filter(Boolean);
      if (!lines.length) continue;
      const labels = copy[language];
      const panel = node('div', 'pfd-promo');
      const brand = node('img', 'pfd-promo-logo');
      brand.src = logo;
      brand.alt = 'QuickSleeper Pain Free Dentistry';
      brand.width = 210;
      brand.height = 48;
      panel.append(brand, node('p', 'pfd-promo-eyebrow', labels.eyebrow));
      const heading = node('h2', 'pfd-promo-title', labels.title);
      heading.id = `pfd-promo-title-${id}`;
      panel.append(heading);
      const offers = node('div', 'pfd-promo-offers');
      // Preserve every line, including the checkout terms, without inferring eligibility.
      lines.forEach(line => {
        const offer = node('p', /\d\s*%/.test(line) ? 'pfd-promo-offer' : 'pfd-promo-note');
        offer.textContent = line;
        offers.append(offer);
      });
      panel.append(offers);
      const action = node('button', 'pfd-promo-continue', labels.continue);
      action.type = 'button';
      action.append(node('span', 'pfd-promo-arrow', '→'));
      action.lastChild.setAttribute('aria-hidden', 'true');
      action.addEventListener('click', () => close.click());
      panel.append(action);
      content.append(panel);
      card.dataset.pfdPromo = language;
      card.closest('#pc-modal-backdrop')?.setAttribute('data-pfd-promo-backdrop', '');
      card.setAttribute('role', 'dialog');
      card.setAttribute('aria-modal', 'true');
      card.setAttribute('aria-labelledby', heading.id);
      card.lang = language;
      close.setAttribute('role', 'button');
      close.setAttribute('aria-label', labels.close);
      close.tabIndex = 0;
      close.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          close.click();
        }
      });
      const previousFocus = document.activeElement;
      const onKey = event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close.click();
        } else if (event.key === 'Tab') {
          event.preventDefault();
          (root.activeElement === action ? close : action).focus();
        }
      };
      document.addEventListener('keydown', onKey);
      close.focus({ preventScroll: true });
      const cleanup = new MutationObserver(() => {
        if (card.isConnected) return;
        document.removeEventListener('keydown', onKey);
        if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
        cleanup.disconnect();
      });
      cleanup.observe(root, { childList: true, subtree: true });
    }
  }

  let attempts = 0;
  const connect = () => {
    const root = document.querySelector('#pop-convert-app')?.shadowRoot;
    if (!root) return false;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = stylesheet;
    // If the stylesheet cannot load, leave the original app presentation alone.
    link.addEventListener('load', () => {
      enhance(root);
      new MutationObserver(() => enhance(root)).observe(root, { childList: true, subtree: true });
    }, { once: true });
    root.append(link);
    return true;
  };
  if (!connect()) {
    const timer = window.setInterval(() => {
      if (connect() || ++attempts >= 120) window.clearInterval(timer);
    }, 250);
  }
})();
